<template>
  <div>
    <div class="nav">
      <!-- 导航栏 -->
      <!-- <div class="banner">
        <el-carousel trigger="click" indicator-position="none" autoplay>
          <el-carousel-item v-for="(item,index) in tu" :key="index">
            <img :src="item.titlePhoto" class="tu" @click="jump2(item.linkurl,item.contentId,item.channelId)"/>
          </el-carousel-item>
        </el-carousel>
        <div class="ding">
          <ul>
          	<li v-for="(item,index) in list" :key="index">
              <div v-if="item.id==1" style="position: relative;">
                <div class="ding_tu1">
                  <img src="../../assets/gao.png" alt="">
                  <div class="ding_txt1">{{item.txt}}</div>
                </div>
                <div class="ding_shu"></div>
              </div>
              <div v-if="item.id!=1" style="position: relative;cursor: pointer;" @mouseover="addtop(1,item.id)" @mouseout="addtop(2,item.id)" @click="jump(index)">
                <div style="width: 50%;margin: 0 auto;text-align: center;" :class="item.zt?'':'addtop'">
                  <div class="ding_tu2 iconfont" :class="item.name"></div>
                  <div class="ding_txt2">{{item.txt}}</div>
                  <div class="ding_shu" v-if="item.id!=list.length"></div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div> -->
      <div>

      </div>

      <!-- 资讯 -->
<!--      <Journalism></Journalism> -->

      <clickskip></clickskip>

      <allpages></allpages>

      <!-- 快报 -->

      <!-- <express></express> -->
      <!-- 作者 -->
      <!-- <author></author> -->

      <!-- 精华 -->
      <!-- <Essence></Essence> -->
      <!-- 精彩视频 -->
      <!-- <videobar></videobar> -->
      <div style="width: 100%;height: 43px;background-color: #F7F8FA;"></div>
      <!-- 检索机构 -->
      <!-- <retrieval></retrieval> -->
      <!-- 侧边栏 -->

      <div class="cebian">
        <ul>
          <li :style="{'background':item.colorA}"   v-for="(item,index) in cebian" :key="index" @mouseover="xuan(1,index)" @mouseout="xuan(2,index)"  @click="zhitop(index)">
            <!-- <div :class="item.name"></div> -->
            <img :src="item.img"  style="float:left;margin:15px -20px 0 10px;" alt="">
            <div style="fontSize:18px;marginTop:2px">{{item.name}}</div>
          </li>
        </ul>
      </div>

      <!-- <div class="cebian2" v-if="num==4 || num==5" :class="num==4?'top1':'top2'">

        <div v-if="num==4">2718811287</div>

      </div> -->

      <div class="pubMobLeft_right_cont" >

        <!-- <div class="pubMobLeft_right_top" >
          <img src="/src/assets/xhapp.png">
        </div> -->
        <div class="pubMobLeft_right_mid" v-if="num==4" >
          <img src="/src/assets/fw.jpg">
        </div>
        <div class="pubMobLeft_right_mid" v-if="num==3" >
          <img src="/src/assets/fw1.jpg">
        </div>
        <div class="pubMobLeft_right_mid"  v-if="num==1">
          <img src="/src/assets/xhgzh.jpg">
        </div>
         <div class="pubMobLeft_right_mid" v-if="num==2" >
          <img src="/src/assets/xhxcx.png">
        </div>
      </div>

    </div>
  </div>
</template>

<script>
//资讯
import Journalism from "../public/home/Journalism.vue"
//快报
import express from "../public/home/express.vue"
//作者
import author from "../public/home/author.vue"
//精华
import Essence from "../public/home/Essence.vue"
//视频
import videobar from "../public/home/video.vue"
//检索机构
import retrieval from "../public/home/retrieval.vue"
//点击跳转
import clickskip from "../public/home/clickSkip.vue"

//首页中间部分
import allpages from "../public/home/homeMain/index.vue"

//首页右边部分
import allright from "../public/home/homeRight.vue"

  export default {
    components: {
      retrieval,
      Journalism,
      express,
      author,
      Essence,
      videobar,
      clickskip,
      allpages,
      allright
    },
    data() {
      return {
        num: 0,
        cebian:[
          {
             img:require('../../assets/gzh.png'),
             colorA:'#FF5F3E',
             name:'公众号'
          },
          {
             img:require('../../assets/xcx.png'),
             colorA:'#10D2B5',
             name:'小程序'
          },
          {
             img:require('../../assets/app.png'),
             colorA:'#6A6AFF',
             name:'小程序'
          },

          {
             img:require('../../assets/QQ.png'),
             colorA:'#FF4641',
             name:'公众号'
          }
        ],
        Visits: 0,//访问量
        tu: [],//轮播图
        list: [
          {
            id: 1,
            name: '',
            txt: '稿 件专 区',
            zt: false
          },
          {
            id: 2,
            name: 'icontougaogaojian',
            txt: '作者投稿',
            zt: false
          },
          {
            id: 3,
            name: 'iconlunwen',
            txt: '编辑办公',
            zt: false
          },
          {
            id: 4,
            name: 'iconpingshenzhuanjiashu',
            txt: '专家审核',
            zt: false
          },
          {
            id: 5,
            name: 'icondingyue',
            txt: '在线订阅',
            zt: false
          }
        ],
      }
    },
    methods: {
      //点击置顶页面
      zhitop(index){
        if(index==3){
          document.documentElement.scrollTop = 0;
        }
      },
      //悬停侧边栏
      xuan(num,id){
        if(num==1){
          this.num = id+1;
          console.log(this.num)
          for(var i=0;i<this.cebian.length;i++){
            if(id==i){
              this.cebian[i].zt = true;
              this.cebian.push('1');
              this.cebian.pop('1');
            }
          }
        }else{
          this.num = 0;
          for(var i=0;i<this.cebian.length;i++){
            this.cebian[i].zt = false;
            this.cebian.push('1');
            this.cebian.pop('1');
          }
        }
      },
      jump2(linkurl,contentId,channelId){
        if(linkurl!=null){
          window.open(linkurl);
        }else{
          this.$router.push({path:'/expert_details',query:{num: 9,contentId: contentId,channelId:channelId}});
        }
      },
      GetHomePagePicture(channelId){
        var that = this;
        that.$httphelper.GetHomePagePicture({
          "journalId": that.$_JournalId,
          "channelId": channelId,
        }).then(res => {
          if(res.code==200){
            that.tu = res.data || '';
            that.$loading.hideLoading();
          }else{

          }
        });
      },
      jump(index){
        if(index==0){
          window.open('http://zhgxyzz.boyuancb.com/checkout');
        }else if(index==1){
          window.open('http://zhgxyzz.boyuancb.com/checkout');
        }else if(index==2){
          window.open('http://zhgxyzz.boyuancb.com/checkout');
        }else if(index==3){
          window.open('http://zhgxyzz.boyuancb.com/checkout');
        }
      },
      //鼠标悬停
      addtop(num,id){
        if(num==1){
          for(var i=0;i<this.list.length;i++){
            if(id==this.list[i].id){
              this.list[i].zt = true;
              this.list.push('1');
              this.list.pop('1');
            }
          }
        }else{
          for(var i=0;i<this.list.length;i++){
            this.list[i].zt = false;
            this.list.push('1');
            this.list.pop('1');
          }
        }
      },
    },
    created() {
      sessionStorage.setItem('routerIndex',0);
      this.GetHomePagePicture(3090);
    }
  }
</script>

<style lang="scss" scoped>
  * {
    margin: 0;
    padding: 0;
  }
         /deep/ .el-carousel__container{
        width: 100%;
        height: 450px;
  .nav{
    min-width: 1366px;
    background-color: #FFFFFF;

    .banner{
      width: 40%;
      min-width: 1366px;
      height: 420px;
      position: relative;

        .tu{
          width: 100%;
          height: 100%;
          object-fit: cover;
          cursor: pointer;
        }
        .tu:hover{
          transform: scale(1.05);
        }
      }
      /deep/ .el-carousel__arrow{
        font-size: 28px;
        background-color: #FFFFFF;
        opacity: 0.3;
        color: black;
      }
      .ding{
        width: 85%;
        height: 100px;
        margin: 0 auto;
        background: #FFFFFF;
        background: rgba(255,255,255,0.1);
        border-radius: 4px;
        position: absolute;
        bottom: 0;
        left: 7.5%;
        z-index: 2;
        padding-top: 14px;
        ul{
          width: 85%;
          margin: 0 auto;
          overflow: hidden;
          list-style: none;
          li{
            width: 20%;
            min-width: 74px;
            float: left;
            overflow: hidden;
            .ding_tu1{
              width: 87px;
              margin: 0 auto;
              position: relative;
              img{
                width: 87px;
                height: 80px;
              }
              .ding_txt1{
                width: 50px;
                position: absolute;
                left: 23px;
                top: 15px;
                font-size: 18px;
                font-family: Source Han Sans SC;
                color: #FFFFFF;
                line-height: 20px;
              }
            }
            .ding_tu2{
              color: #FFFFFF;
              font-size: 30px;
              margin-bottom: 10px;
            }
            .ding_txt2{
              font-size: 18px;
              font-family: Source Han Sans SC;
              color: #FFFFFF;
              line-height: 38px;
            }
            .ding_shu{
              position: absolute;
              top: 25px;
              right: 0;
              width: 2px;
              height: 36px;
              background: #FFFFFF;
              z-index: 10;
            }
          }
        }
      }
    }
  }
  .addtop{
    padding-top: 10px;
  }

  .cebian2{
    width: 145px;
    height: 41px;
    border: 1px solid #F2F2F2;
    box-shadow: 0px 2px 12px 0px rgba(191, 191, 191, 0.5);
    z-index: 100000000;
    position: fixed;
    right: 160px;
    top: 39%;
    background-color: #FFFFFF;
    text-align: center;
    line-height: 41px;
  }

  .pubMobLeft_right_cont{
    width: 145px;
    // height: 255px;
    position: fixed;
    z-index: 100000000;
    right: 160px;
    top: 38%;

    .pubMobLeft_right_top{
      width: 100%;
      height: 54px;
      img{
        width: 100%;
        height: 100%;
        border-style: none;
        object-fit: cover;
      }
    }
    .pubMobLeft_right_mid{
      width: 100%;
      max-height: 200px;
      img{
        width: 100%;
        max-height: 100%;
        border: 1px solid #ccc;
      }
    }
    .pubMobLeft_right_bto{
      width: 100%;
      background: #b91e25;
      color: #fff;
      text-align: center;
      height: 38px;
      line-height: 38px;
      font-size: 14px;
      padding-top: 10px;
    }
    .pubMobLeft_right_close{
      font-size: 15px;
      color: #000;
      cursor: pointer;
      padding-top: 5px;
      background: #FFFFFF;
      width: 100%;
    }
  }

  .cebian{
    width: 140px;
    overflow: hidden;
    position: fixed;
    right: 10px;
    top: 38%;
    z-index: 100000000;
    ul{
      list-style: none;
      width: 100%;
      overflow: hidden;
      li{
        cursor: pointer;
        margin-bottom: 11px;
        float: left;
        width: 100%;
        height: 56px;
        background: #DDDDDD;
        opacity: 0.8;
        text-align: center;
        div{
          margin: 0 auto;
          color: #FFFFFF;
          font-size: 25px;
          line-height: 56px;
        }
      }
    }
  }
  .bianse{
    background-color: #E5332D!important;
    color: #FFFFFF!important;
  }
  .top1{
    top: 57.5%!important;
  }
  .top2{
    top: 65.5%!important;
  }
</style>



// WEBPACK FOOTER //
// src/components/nav/home.vue